"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CurrentProjectProvider = exports.useCurrentProjectContext = void 0;
const React = __importStar(require("react"));
const react_router_dom_1 = require("react-router-dom");
const AppRouting_1 = require("src/hello_assets/src/components/system/AppRouting");
const ProjectsProvider_1 = require("src/hello_assets/src/components/ui/loggedin/content/common/provider/ProjectsProvider");
const lodash_1 = __importDefault(require("lodash"));
const MainRedirectComponent_1 = require("src/hello_assets/src/components/ui/loggedin/content/common/provider/MainRedirectComponent");
const CurrentProjectContext = React.createContext({});
const useCurrentProjectContext = () => React.useContext(CurrentProjectContext);
exports.useCurrentProjectContext = useCurrentProjectContext;
const CurrentProjectProvider = ({ children }) => {
    const match = (0, react_router_dom_1.useRouteMatch)(AppRouting_1.PATH__PROJECT);
    const projectsContext = (0, ProjectsProvider_1.useProjectsContext)();
    let value = undefined;
    let projectApiKeyToSearchFor;
    if (match) {
        projectApiKeyToSearchFor = match.params.projectApiKey;
    }
    else {
        projectApiKeyToSearchFor = MainRedirectComponent_1.LastProjectStorage.getProject();
    }
    if (!lodash_1.default.isEmpty(projectApiKeyToSearchFor)) {
        const projectData = lodash_1.default.find(projectsContext.projectsState.data, function ({ view: projectProfileView }) {
            return lodash_1.default.isEqual(projectProfileView.projectApiKey, projectApiKeyToSearchFor);
        });
        if (projectData) {
            value = projectData.view;
        }
    }
    return React.createElement(CurrentProjectContext.Provider, { value: value }, children);
};
exports.CurrentProjectProvider = CurrentProjectProvider;
